import { Divider } from '@ds';
import Connection from '@lp/assets/images/Connection.svg';
import { TrialProgramImage, UnosIdButton } from '@ui';
import { CaseFacility, DonorType, OrganType } from '@/api/apis/case';
import { getColorsByOrganType } from '@/utils/helpers';
import HeaderCard from './HeaderCard';
import { Uuid } from '@/api/types';
import { CaseStatusMenu } from './CaseStatusMenu';
import { TrialProgram } from '@/api/apis/facilities/trial-programs';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

type HeaderProps = {
  caseId: Uuid;
  donorType: DonorType;
  organType: OrganType;
  donorHospital?: CaseFacility;
  txHospital?: CaseFacility;
  trialProgram?: TrialProgram;
  donorId: string;
  caseSuffixes: string;
};

const Header = ({
  caseId,
  donorType,
  donorId,
  caseSuffixes,
  organType,
  donorHospital,
  txHospital,
  trialProgram,
}: HeaderProps) => {
  const colors = getColorsByOrganType(organType);
  const { resolveSubdivisionName } = useCountriesData();

  return (
    <div className="flex flex-col px-8 py-5 gap-8">
      <div className="flex flex-wrap justify-between items-center gap-4">
        <div className="flex items-center gap-2 text-hxl flex-wrap">
          <h2 className={colors.textDefault}>{donorType}</h2>
          <Divider className="h-10" orientation="vertical" />
          <UnosIdButton
            suffixColor={colors.textDefault}
            caseSuffixes={caseSuffixes}
            donorId={donorId}
            containerClassName="text-3xl mr-2"
          />
          <TrialProgramImage organ={trialProgram?.organ} />
          <CaseStatusMenu caseId={caseId} />
        </div>
        <div className="flex items-center gap-2">
          {donorHospital && (
            <HeaderCard
              image={donorHospital.logoPath}
              label={donorHospital.name}
              code={donorHospital.code}
              state={resolveSubdivisionName(donorHospital.location?.state, donorHospital.location?.country)}
            />
          )}
          <Connection />
          {txHospital && (
            <HeaderCard
              image={txHospital.logoPath}
              label={txHospital.name}
              code={txHospital.code}
              state={resolveSubdivisionName(txHospital.location?.state, txHospital.location?.country)}
            />
          )}
        </div>
      </div>
      {/* <HeaderTimeline organType={organType} /> */}
    </div>
  );
};

export default Header;
